/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import ConfirmAction from './ConfirmAction/index'
import MatchesFilter from './MatchesFilter/index'
import React from 'react'
import RefreshAction from './RefreshAction/index'
import TableX from 'DesignSystem/TableX/react'
import TreatmentStatus from './TreatmentStatus/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Settings/AdminContent/SettingsContent/IntegrationsApplications/Content/SyncPatients/Content/SyncPatients/Content",
  value
  
}) {
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtSpaceLs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ls'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 style={{'--bc-1-Z1Yf8zk': dtColorsNeutral200}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 style={{'--bbc-2-Z1Yf8zk': dtColorsNeutral200,'--pl-3-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pr-4-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pt-5-Z1Yf8zk': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--pb-6-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="Content.Horizontal:1"
  data-view-path={viewPath}
 style={{'--g-7-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal1}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 width={160}
 size="small"
 text="Show patients with"
/>
<TreatmentStatus
  viewPath={`${viewPath}/TreatmentStatus`}
/>
</div>
<div
  data-testid="Content.Horizontal:2"
  data-view-path={viewPath}
 style={{'--g-7-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal2}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="Showing"
/>
<MatchesFilter
  viewPath={`${viewPath}/MatchesFilter`}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="matches"
/>
<RefreshAction
  viewPath={`${viewPath}/RefreshAction`}
/>
<ConfirmAction
  viewPath={`${viewPath}/ConfirmAction`}
/>
</div>
</div>
<TableX
  viewPath={`${viewPath}/TableX`}
 virtual={true}
 marginRight={0}
 marginLeft={0}
 marginTop={0}
 marginBottom={0}
 borderRadius={0}
 borderWidth={0}
 rightBorder={true}
 paddingRightCell={0}
 paddingLeftCell={0}
 height={800}
 value={value}
/>
</div>
{children}
</React.Fragment>)
}